// Common
import { Inject, Injector, Optional, Pipe, untracked, type PipeTransform, type Signal } from '@angular/core';
import { listWorkspaceScope } from '@modules/common/components/item-workspace/list-workspace-scope';
import { checkExhaustiveness } from '@modules/common/utils/switch';

// Types
import { VirtualFolder } from '../types/virtual-folder';

@Pipe({
  name: 'titleByNotesFilter',
  standalone: false,
  pure: false,
})
export class TitleByNotesFilterPipe implements PipeTransform {
  private workspaceScope?: Signal<'team' | 'mine' | undefined>;

  public constructor(@Optional() @Inject(Injector) private readonly injector: Injector | null = null) {}

  public transform(value: VirtualFolder, containerName?: string | null, nameWorkspace = false): string {
    const injector = this.injector;
    if (nameWorkspace && value === 'all_notes' && injector) {
      this.workspaceScope ??= untracked(() => listWorkspaceScope(injector));
      const workspace = this.workspaceScope();
      if (workspace) return `${workspace === 'team' ? 'Team' : 'My'} Notes`;
    }
    if (!value) {
      return containerName || 'All';
    }

    switch (value) {
      case 'search_results':
        // One spelling per screen: the rail's own row already reads `All results` (#1223). The other
        // apps' pipes keep `All Results` until they are migrated in turn.
        return 'All results';
      case 'all_notes':
        return 'Notes';
      case 'following':
        return 'Following';
      case 'assigned_to_me':
        return 'Assigned to me';
      case 'flagged':
        return 'Flagged';
      case 'followed':
        return 'Follow Up';
      case 'archived':
        return 'Archive';
      case 'deleted':
        return 'Trash';
      case 'all_notebooks':
        return 'Notebooks';
      case 'snoozed':
        return 'Snoozed';
      default:
        return checkExhaustiveness(value);
    }
  }
}
